import { render, staticRenderFns } from "./V3DApp.vue?vue&type=template&id=2578d3e4&"
import script from "./V3DApp.vue?vue&type=script&lang=js&"
export * from "./V3DApp.vue?vue&type=script&lang=js&"
import style0 from "./V3DApp.vue?vue&type=style&index=0&lang=less&"
import style1 from "./V3DApp.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports